// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bcf_a bhy_a bhy_q bhy_j bhy_wl bhy_bj","ImgResponsive__img":"bcf_b bhy_b bhy_ql"};